var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSalesforce = function SvgSalesforce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#salesforce_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A1E0",
    d: "M8.319 4.529a3.53 3.53 0 0 1 2.54-1.093c1.323 0 2.47.739 3.085 1.831a4.3 4.3 0 0 1 1.75-.37c2.386 0 4.313 1.948 4.313 4.349 0 2.4-1.938 4.348-4.32 4.348a4.3 4.3 0 0 1-.846-.085 3.16 3.16 0 0 1-2.755 1.616 3.2 3.2 0 0 1-1.378-.313 3.594 3.594 0 0 1-6.684-.162 3.4 3.4 0 0 1-.685.07C1.493 14.717 0 13.21 0 11.34a3.38 3.38 0 0 1 1.67-2.925 3.8 3.8 0 0 1-.323-1.547c-.008-2.131 1.739-3.871 3.878-3.871a3.88 3.88 0 0 1 3.093 1.531"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "salesforce_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgSalesforce;